/* Custom bundle front end on window.CartCatalyst (storefront.md).
   Rules honored: read initial state — cc:bundle:change fires before listeners
   attach; NEVER compute totals (discountedTotal only, HP10); required
   components cannot be declined; retail compare via retailTotal()/compareOf().
   Emits legacy GA4 names: sub_product_click_add / _remove / _all. */
(function () {
  var builder = document.querySelector('[data-bundle-builder]');
  if (!builder) return;

  function whenReady(cb, tries) {
    if (window.CartCatalyst && window.CartCatalyst.bundles && window.CartCatalyst.bundles.length) return cb(window.CartCatalyst.bundles[0]);
    if ((tries || 0) > 100) return; /* no instance: block absent/misconfigured — page stays a plain PDP by design */
    setTimeout(function () { whenReady(cb, (tries || 0) + 1); }, 100);
  }

  whenReady(function (b) {
    var requiredWrap = builder.querySelector('[data-bundle-required]');
    var addonsWrap = builder.querySelector('[data-bundle-addons]');
    var addonsHead = builder.querySelector('[data-bundle-addons-head]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var contents = document.querySelector('[data-bundle-contents]');
    var contentsList = document.querySelector('[data-bundle-contents-list]');
    var strings = window.tdtStrings;

    function variantLabel(v) { return (v.optionValues || []).join(' / ') || v.id; }
    function gidOf(v) { return 'gid://shopify/ProductVariant/' + v.id; }

    /* Add-on photos: product GID → image URL. Liquid supplies the kit's
       sub_products; anything else (e.g. an add-on the app attaches outside that
       list) is fetched once from the tokenless Storefront API. No photo → the
       wrench stays. */
    var photos = {};
    try { photos = JSON.parse(document.querySelector('[data-bundle-photos]').textContent) || {}; } catch (e) {}
    function photoImg(src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 52;
      img.height = 52;
      return img;
    }
    var missing = b.contract.components
      .filter(function (c) { return !c.required && !photos[c.productGid]; })
      .map(function (c) { return c.productGid; });
    if (missing.length) {
      fetch('/api/2025-10/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: 'query($ids:[ID!]!){ nodes(ids:$ids){ ... on Product { id featuredImage { url(transform:{maxWidth:120}) } } } }',
          variables: { ids: missing }
        })
      }).then(function (r) { return r.json(); }).then(function (res) {
        ((res.data && res.data.nodes) || []).forEach(function (n) {
          if (!n || !n.featuredImage) return;
          photos[n.id] = n.featuredImage.url;
          document.querySelectorAll('[data-addon-photo="' + n.id + '"]').forEach(function (el) {
            el.innerHTML = '';
            el.appendChild(photoImg(n.featuredImage.url));
          });
        });
      }).catch(function () {});
    }
    function selectedVariant(comp) {
      var g = b.selection()[comp.seq];
      var out = comp.variants[0];
      comp.variants.forEach(function (v) { if (gidOf(v) === g) out = v; });
      return out;
    }
    /* Option groups worth showing (skip Default Title / single-value groups) */
    function realOptions(comp) {
      return (comp.options || [])
        .map(function (o, i) { return { name: o.name, values: o.values || [], idx: i }; })
        .filter(function (o) { return o.values.length > 1; });
    }
    /* Change one option group's value; resolve the matching variant, falling
       back to the first variant carrying that value if the combo doesn't exist */
    function pickVariant(comp, optIdx, value) {
      var want = (selectedVariant(comp).optionValues || []).slice();
      want[optIdx] = value;
      var exact = comp.variants.filter(function (v) {
        return (v.optionValues || []).every(function (ov, i) { return ov === want[i]; });
      })[0];
      if (exact) return { v: exact, moved: false };
      var fallback = comp.variants.filter(function (v) { return (v.optionValues || [])[optIdx] === value; })[0];
      return { v: fallback || selectedVariant(comp), moved: true };
    }
    /* One segmented slider per option group (same markup as the theme's
       option-slider snippet so the sliding thumb picks it up) */
    function optionFieldset(comp, opt, onPicked) {
      var fs = document.createElement('fieldset');
      fs.className = 'option-slider option-slider--js option-slider--sub';
      fs.setAttribute('data-option-slider', '');
      var lg = document.createElement('legend');
      lg.className = 'option-slider__legend';
      lg.textContent = opt.name;
      fs.appendChild(lg);
      var track = document.createElement('div');
      track.className = 'option-slider__track';
      var curVals = selectedVariant(comp).optionValues || [];
      opt.values.forEach(function (val, i) {
        var id = 'cc-' + comp.seq + '-o' + opt.idx + '-' + i;
        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'option-slider__input sr-only';
        input.name = 'cc-comp-' + comp.seq + '-o' + opt.idx;
        input.id = id;
        input.checked = curVals[opt.idx] === val;
        input.addEventListener('change', function () {
          var res = pickVariant(comp, opt.idx, val);
          b.set(comp.seq, gidOf(res.v));
          if (res.moved) {
            /* combo forced other groups to move — resync the whole builder */
            renderComponents();
            if (window.tdtInitSliders) window.tdtInitSliders(document);
          } else if (onPicked) {
            onPicked(res.v);
          }
        });
        var label = document.createElement('label');
        label.className = 'option-slider__segment';
        label.setAttribute('for', id);
        label.textContent = val;
        track.appendChild(input);
        track.appendChild(label);
      });
      fs.appendChild(track);
      return fs;
    }

    function renderComponents() {
      var selection = b.selection();
      requiredWrap.innerHTML = '';
      /* clear previous add-on cards but keep the section heading */
      addonsWrap.querySelectorAll('.pdp-addon').forEach(function (c) { c.remove(); });
      var hasAddons = false;
      b.contract.components.forEach(function (comp) {
        if (comp.required) {
          /* "What's included": component title + one slider per option group */
          var wrap = document.createElement('div');
          wrap.className = 'pdp-comp';
          var t = document.createElement('p');
          t.className = 'pdp-comp__title';
          t.textContent = comp.title;
          wrap.appendChild(t);
          realOptions(comp).forEach(function (opt) {
            wrap.appendChild(optionFieldset(comp, opt, null));
          });
          requiredWrap.appendChild(wrap);
        } else {
          hasAddons = true;
          var on = !!selection[comp.seq];
          var multi = comp.variants.length > 1;
          var selVar = selectedVariant(comp);
          var card = document.createElement('div');
          card.className = 'pdp-addon' + (on ? ' pdp-addon--on' : '');
          card.setAttribute('data-addon-seq', comp.seq);

          var row = document.createElement('div');
          row.className = 'pdp-addon__row';
          var photo = document.createElement('span');
          photo.className = 'pdp-addon__photo';
          photo.setAttribute('data-addon-photo', comp.productGid);
          if (photos[comp.productGid]) photo.appendChild(photoImg(photos[comp.productGid]));
          else photo.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>';
          var info = document.createElement('div');
          info.className = 'pdp-addon__info';
          var titleRow = document.createElement('div');
          titleRow.className = 'pdp-addon__title-row';
          var nameEl = document.createElement('span');
          nameEl.className = 'pdp-addon__name';
          nameEl.textContent = comp.title;
          var infoBtn = document.createElement('button');
          infoBtn.type = 'button';
          infoBtn.className = 'pdp-addon__q';
          infoBtn.setAttribute('aria-label', strings.moreInfo);
          infoBtn.textContent = '?';
          titleRow.appendChild(nameEl);
          titleRow.appendChild(infoBtn);
          var priceRow = document.createElement('div');
          priceRow.className = 'pdp-addon__price-row';
          var priceEl2 = document.createElement('span');
          priceEl2.className = 'pdp-addon__price';
          priceEl2.textContent = '+ ' + b.money(b.priceOf(selVar));
          priceRow.appendChild(priceEl2);
          var hint = document.createElement('span');
          hint.className = 'pdp-addon__hint';
          hint.textContent = strings.optionsHint.replace('%d', String(comp.variants.length));
          hint.hidden = !(multi && !on);
          priceRow.appendChild(hint);
          info.appendChild(titleRow);
          info.appendChild(priceRow);

          var toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'pdp-addon__toggle' + (on ? ' pdp-addon__toggle--on' : '');
          toggle.setAttribute('role', 'switch');
          toggle.setAttribute('aria-checked', on ? 'true' : 'false');
          toggle.setAttribute('aria-label', comp.title);
          toggle.innerHTML = '<span class="pdp-addon__knob"></span>';
          toggle.addEventListener('click', function () {
            var nowOn = !b.selection()[comp.seq];
            if (nowOn) b.set(comp.seq, gidOf(selectedVariant(comp)));
            else b.toggle(comp.seq, false);
            if (window.dataLayer) window.dataLayer.push({ event: nowOn ? 'sub_product_click_add' : 'sub_product_click_remove', component: comp.title });
            /* animate in place — a rebuild would skip the knob/card transitions */
            toggle.classList.toggle('pdp-addon__toggle--on', nowOn);
            toggle.setAttribute('aria-checked', nowOn ? 'true' : 'false');
            card.classList.toggle('pdp-addon--on', nowOn);
            hint.hidden = !(multi && !nowOn);
            if (nowOn) {
              if (!optsEl) { optsEl = buildOptions(); if (optsEl) { card.appendChild(optsEl); if (window.tdtInitSliders) window.tdtInitSliders(card); } }
            } else if (optsEl) {
              optsEl.remove();
              optsEl = null;
            }
          });

          row.appendChild(photo);
          row.appendChild(info);
          row.appendChild(toggle);
          card.appendChild(row);

          var tip = document.createElement('div');
          tip.className = 'pdp-addon__tip';
          tip.hidden = true;
          tip.innerHTML = '<p class="pdp-addon__tip-title">' + comp.title.toUpperCase() + '</p>' +
            '<p class="pdp-addon__tip-body">' + (multi ? strings.tipMulti.replace('%d', String(comp.variants.length)) : strings.tipSingle) + '</p>' +
            '<div class="pdp-addon__tip-foot"><span class="pdp-addon__tip-price">+ ' + b.money(b.priceOf(selVar)) + ' ' + strings.tipSuffix + '</span>' +
            '<button type="button" class="pdp-addon__tip-close">' + strings.close + ' ✕</button></div>';
          infoBtn.addEventListener('click', function () {
            tip.hidden = !tip.hidden;
            infoBtn.classList.toggle('pdp-addon__q--active', !tip.hidden);
          });
          tip.addEventListener('click', function (e) {
            if (e.target.closest('.pdp-addon__tip-close')) { tip.hidden = true; infoBtn.classList.remove('pdp-addon__q--active'); }
          });
          card.appendChild(tip);

          function buildOptions() {
            var ropts = realOptions(comp);
            if (!ropts.length) return null;
            var opts = document.createElement('div');
            opts.className = 'pdp-addon__options';
            ropts.forEach(function (opt) {
              opts.appendChild(optionFieldset(comp, opt, function (v) {
                priceEl2.textContent = '+ ' + b.money(b.priceOf(v));
                var tp = tip.querySelector('.pdp-addon__tip-price');
                if (tp) tp.textContent = '+ ' + b.money(b.priceOf(v)) + ' ' + strings.tipSuffix;
              }));
            });
            return opts;
          }
          var optsEl = null;
          if (on) { optsEl = buildOptions(); if (optsEl) card.appendChild(optsEl); }
          addonsWrap.appendChild(card);
        }
      });
      if (addonsHead) addonsHead.classList.toggle('is-hidden', !hasAddons);
    }

    function renderTotals(detail) {
      var total = detail ? detail.discountedTotal : b.discountedTotal();
      if (priceEl) priceEl.textContent = b.money(total);
      if (stickyPrice) stickyPrice.textContent = b.money(total);
      if (compareEl && b.tier !== b.contract.baseTier) {
        compareEl.textContent = b.money(b.retailTotal()) + ' ' + window.tdtStrings.retail;
        compareEl.classList.remove('is-hidden');
      }
    }

    function renderMeter(detail) {
      /* Real ladder shape (read from the block's shipped API): b.ladder is
         { rungs: [{min, amount, kind}] }; earned() returns a rung; next()
         returns { rung, away }. Amounts can be percent or fixed. */
      var meters = document.querySelectorAll('[data-tier-meter]');
      var rungs = (b.ladder && b.ladder.rungs) || [];
      if (!rungs.length) { meters.forEach(function (m) { m.classList.add('is-hidden'); }); return; }
      var earned = detail ? detail.earned : b.earned();
      var next = detail ? detail.next : b.next();
      var subtotal = detail && typeof detail.total === 'number' ? detail.total : b.total();
      /* Dollar savings straight off the API pair — never our own arithmetic
         beyond the difference of the two numbers the till already agrees on */
      var discounted = detail && typeof detail.discountedTotal === 'number' ? detail.discountedTotal : b.discountedTotal();
      var saved = Math.max(0, subtotal - discounted);
      var earnedIdx = -1;
      if (earned) rungs.forEach(function (r, i) { if (r.min === earned.min) earnedIdx = i; });
      var tierCols = ['#4AA7DD', '#5FCB8B', '#E8C46B', '#E06A3B'];
      var dullCols = ['#173242', '#1A3626', '#3A3122', '#3B2417'];
      meters.forEach(function (meter) {
        meter.classList.remove('is-hidden');
        var segs = meter.querySelector('[data-tier-segs]');
        if (segs && segs.children.length !== rungs.length) {
          segs.innerHTML = '';
          rungs.forEach(function () {
            var sEl = document.createElement('span');
            sEl.className = 'tier-meter__seg';
            segs.appendChild(sEl);
          });
        }
        if (segs) {
          Array.prototype.forEach.call(segs.children, function (sEl, i) {
            var wasLit = sEl.dataset.lit === '1';
            var lit = i <= earnedIdx;
            sEl.style.background = lit ? tierCols[Math.min(i, 3)] : dullCols[Math.min(i, 3)];
            if (lit && !wasLit && sEl.dataset.lit !== undefined) {
              sEl.classList.remove('tier-meter__seg--pulse');
              void sEl.offsetWidth;
              sEl.classList.add('tier-meter__seg--pulse');
              sEl.addEventListener('animationend', function cleanup() {
                sEl.classList.remove('tier-meter__seg--pulse');
                sEl.removeEventListener('animationend', cleanup);
              });
            }
            sEl.dataset.lit = lit ? '1' : '0';
          });
        }
        var fill = meter.querySelector('[data-tier-fill]');
        var amount = meter.querySelector('[data-tier-amount]');
        var head = meter.querySelector('[data-tier-head]');
        var foot = meter.querySelector('[data-tier-foot]');
        var col = tierCols[Math.min(earnedIdx + 1, 3)];
        var isMax = earnedIdx >= rungs.length - 1;
        if (isMax) {
          if (fill) { fill.style.width = '100%'; fill.style.background = tierCols[3]; }
          if (amount) amount.textContent = b.money(saved) + ' ' + strings.off;
          if (head) head.textContent = strings.maxHead;
          if (foot) foot.textContent = strings.maxFoot;
        } else if (next) {
          var floor = earnedIdx >= 0 ? rungs[earnedIdx].min : 0;
          var span = next.rung.min - floor;
          var progressed = Math.max(0, subtotal - floor);
          var pct = Math.max(4, Math.min(100, Math.round((progressed / span) * 100)));
          if (fill) { fill.style.width = pct + '%'; fill.style.background = col; }
          if (amount) {
            if (earned) amount.textContent = b.money(saved) + ' ' + strings.off;
            else if (subtotal <= 0) amount.textContent = b.money(0);
            else amount.textContent = b.money(next.away) + ' \u2192 ' + strings.nextTier;
          }
          if (head) head.textContent = earned ? strings.tierEarned.replace('%n', String(earnedIdx + 1)) : strings.unlockFirst;
          if (foot) foot.textContent = strings.tierNext.replace('%a', b.money(next.away));
        }
      });
    }

    function renderContents() {
      if (!contents || !contentsList) return;
      var selection = b.selection();
      var items = [];
      b.contract.components.forEach(function (comp) {
        if (selection[comp.seq]) items.push(comp.title);
      });
      if (items.length) {
        contents.classList.remove('is-hidden');
        contentsList.innerHTML = items.map(function (t) { return '<p>✓ ' + t + '</p>'; }).join('');
      }
    }

    /* Kit option picker: a custom kit's own options (HP level, TCM…) resolve to a
       parent variant that the app prices via setParentVariant, which also sets the
       form's id. A variant the contract holds no price for can't be bought here,
       so ATC is held rather than adding a variant the page never priced. */
    var parentOpts = document.querySelector('[data-bundle-parent-options]');
    var parentVarsEl = document.querySelector('[data-bundle-parent-variants]');
    if (parentOpts && parentVarsEl && b.setParentVariant) {
      var parentVars = [];
      try { parentVars = JSON.parse(parentVarsEl.textContent); } catch (e) {}
      var atc = document.querySelector('[data-pdp-atc]');
      var atcLabel = atc && atc.querySelector('[data-atc-label]');
      function syncParent() {
        var chosen = [];
        parentOpts.querySelectorAll('[data-option-slider]').forEach(function (slider) {
          var checked = slider.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });
        var match = parentVars.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        })[0];
        if (!match) return;
        var priced = b.setParentVariant('gid://shopify/ProductVariant/' + match.id);
        var buyable = priced && match.available;
        if (match.image && window.tdtSetMainImage) window.tdtSetMainImage(match.image);
        if (atc) {
          atc.disabled = !buyable;
          if (atcLabel) atcLabel.textContent = buyable ? window.tdtStrings.addToCart : window.tdtStrings.soldOut;
        }
      }
      parentOpts.addEventListener('change', syncParent);
      /* tdt-product.js may have switched to a variant that fits the saved truck
         before this instance was ready — apply it now. */
      if (parentOpts.hasAttribute('data-vehicle-adjusted')) syncParent();
    }

    /* Initial read — never wait for the first event (storefront.md timing trap) */
    renderComponents();
    if (window.tdtInitSliders) window.tdtInitSliders(document);
    renderTotals(null);
    renderMeter(null);
    renderContents();

    b.root.addEventListener('cc:bundle:change', function (e) {
      renderTotals(e.detail);
      renderMeter(e.detail);
      renderContents();
    });
  });
})();
